/** @format */

import React from 'react';
import { TableRow } from '@material-ui/core';
import TableCell from '@material-ui/core/TableCell';
import I18n from '../../../components/Translate/I18n';
import { DocumentInterface } from '../../../interfaces/platform/DocumentInterface';
import { DateHelperTs } from '../../../helpers/DateHelperTs';
import DownloadButton from '../../../components/Buttons/DownloadButton';
import RefreshButton from '../../../components/Buttons/RefreshButton';
import oplAppStyle from '../../../assets/themes/OPL/jss/App/OplAppStyle';
import { withStyles } from '@material-ui/core/styles';

export type ReportItemProps = {
    classes: any;
    report: DocumentInterface;
    downloadFileCallback: (document: DocumentInterface, type: string) => void;
    synchronizePivot: (document: DocumentInterface, type: string) => void;
};

const ReportItem = (props: ReportItemProps): React.ReactElement => {
    const tableCellRoot = {root: props.classes.tableCellRoot};
    const tableControlStickyHeader = {root: props.classes.tableControlStickyHeader};
    // const params = JSON.parse(props.report.requestParams);
    // const dateStart = params.dateStart;
    // const dateEnd = params.dateEnd;

    return (
        <TableRow>
            <TableCell classes={tableControlStickyHeader} padding="none" align="left">
                <DownloadButton
                    tooltipTitle={'documents:report.download_report'}
                    callback={(data: { document: DocumentInterface; type: string }): void => {
                        props.downloadFileCallback(data.document, data.type);
                    }}
                    callbackParam={{document: props.report, type: 'document_set'}}
                />
                {props.report.type === 3 && !props.report.synchronized && (
                    <RefreshButton
                        tooltipTitle={'documents:report.synchronize_pivot'}
                        callback={(data: { document: DocumentInterface; type: string }): void => {
                            props.synchronizePivot(data.document, data.type);
                        }}
                        callbackParam={{ document: props.report, type: 'document_set' }}
                    />
                )}
            </TableCell>
            <TableCell classes={tableCellRoot} padding="none" align="left">
                <I18n trans={'documents:report.type.' + props.report.type} />
            </TableCell>
            <TableCell classes={tableCellRoot} padding="none" align="left">
                {props.report.type !== 3 && props.report.processingStartedOn && DateHelperTs.format(props.report.processingStartedOn, 'YYYY-MM-DD')}
                {props.report.type === 3 &&
                    props.report.processingStartedOn &&
                    DateHelperTs.format(props.report.processingStartedOn, 'YYYY-MM-DD HH:mm:ss')}
            </TableCell>
            <TableCell classes={tableCellRoot} padding="none" align="left">
                {props.report.type !== 3 && props.report.completedAt && DateHelperTs.format(props.report.completedAt, 'YYYY-MM-DD')}
                {props.report.type === 3 && props.report.completedAt && DateHelperTs.format(props.report.completedAt, 'YYYY-MM-DD HH:mm:ss')}
            </TableCell>
        </TableRow>
    );
};

export default withStyles(oplAppStyle)(ReportItem);
